<template>
  <div class="title">
    <span> 恭喜，开户成功！为确保账户安全，请您设置证券账户新密码：</span>
  </div>

  <van-field
    v-model="newPassword"
    placeholder="请输入新密码"
    :type="showNew ? 'text' : 'password'"
    :right-icon="showNew ? 'eye-o' : 'closed-eye'"
    :error-message="passwordError"
    @click-right-icon="showNew = !showNew"
    @input="validatePassword"
    clearable
  >
  </van-field>
  <van-field
    v-model="confirmPassword"
    placeholder="请确认新密码"
    :type="showConfirm ? 'text' : 'password'"
    :right-icon="showConfirm ? 'eye-o' : 'closed-eye'"
    :error-message="confirmError"
    @click-right-icon="showConfirm = !showConfirm"
    @input="validateConfirm"
    clearable
  >
  </van-field>
  <div class="tips" style="margin-top: 10px">
    6~20位密码，至少包含数字、英文字母、特殊符号中的2种
  </div>
  <van-button type="primary" @click="submit" style="width: 80%; margin-top: 20px">
    完成
  </van-button>
</template>

<script>
import { Button, Image, Field, CellGroup } from "vant";
import { useStore } from "vuex";
import { onMounted } from "vue";
import { useRoute } from "vue-router";
import httpApi from "../../utils/httpApi";

export default {
  name: "appendix",
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Image.name]: Image,
  },
  data() {
    return {
      newPassword: "",
      showNew: false,
      confirmPassword: "",
      showConfirm: false,
      passwordError: "",
      confirmError: "",
    };
  },
  computed: {
    isPasswordValid() {
      return this.newPassword && !this.passwordError;
    },
    isConfirmValid() {
      return this.confirmPassword && !this.confirmError;
    },
  },
  methods: {
    validatePassword() {
      if (!this.newPassword) {
        this.passwordError = "请输入新密码";
      } else if (this.newPassword.length < 6 || this.newPassword.length > 20) {
        this.passwordError = "密码长度应为6~20位";
      } else if (
        !/^(?=.*[a-zA-Z0-9])(?=.*[a-zA-Z!@#$%^&*])(?=.*[0-9!@#$%^&*]).{6,20}$/.test(
          this.newPassword
        )
      ) {
        this.passwordError = "密码至少包含数字、英文字母、特殊符号中的2种";
      } else {
        this.passwordError = "";
      }
      if (this.confirmPassword) {
        this.validateConfirm();
      }
    },
    validateConfirm() {
      if (!this.confirmPassword) {
        this.confirmError = "请确认新密码";
      } else if (this.confirmPassword !== this.newPassword) {
        this.confirmError = "两次输入的密码不一致";
      } else {
        this.confirmError = "";
      }
    },
    async submit() {
      this.validatePassword();
      this.validateConfirm();

      if (!this.isPasswordValid || !this.isConfirmValid) {
        return;
      }

      const nextUrl = this.$route.query.next_url || this.$route.query.nextUrl || "";
      const res = await httpApi.setPassword({
        password: this.newPassword,
      });
      this.$toast("设置密码成功");
      if (res) {
        if (nextUrl) {
          this.$router.push(nextUrl);
        } else {
          this.$router.back();
        }
      }
    },
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    onMounted(async () => {
      store.commit("setTitleValue", "设置密码");
      store.commit("setStepsShow", false);
    });
    return { route };
  },
};
</script>

<style lang="less">
.title {
  color: @font-color-0;
  font-size: @font-size-1;
  padding-left: @space-2;
  padding-right: @space-2;
  padding-top: @space-2;
  padding-bottom: @space-2;
  text-align: left;
  display: flex;
  // justify-content: space-between;
}

.tips {
  color: @font-color-1;
  font-size: @font-size-3;
}
</style>
